module.exports = __webpack_public_path__ + "img/pubgm-tdm.1a358bd.png";